<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/cartloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "New Purchase",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect,Loader, },
  data() {
    return {
      title: "Stock Consumables",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "New Purchase",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "item.name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingItem: [],

      // Value from user input for adding position
      data: {
        product: "",
        quantity: "",
        unit_price: "",
      },
      itemError: "",
      quantityError: "",
      priceError: "",
      PaidError:"",
      modeError:"",
      supplierError:"",
      totals: {
        date:moment(new Date()).format("YYYY-MM-DD"), 
        total: 0,
        paid: 0,
        mode: 0,
        supplier: 0,
        discount:0,
        invoice:''
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        product: "",
        quantity: "",
        unit_price: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      }
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("consumables", ["SaveStatus","Consumables", "ConsumablesCart"]),
    ...mapGetters("setting", ["PaymentOptions","ReceiptSettings","GeneralSettings"]),
    ...mapGetters("auth",["MyUserPerm"]),
    ...mapGetters("stock", ["Suppliers"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ConsumablesCart ? this.ConsumablesCart.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ConsumablesCart ? this.ConsumablesCart.length : 1;
  },
  methods: {
    ...mapActions({
      FetchConsumables: "consumables/fetchConsumables",
      FetchConsumablesCart: "consumables/fetchConsumablesCart",
      AddCart: "consumables/addToConsumableCart",
      DeleteCartItem: "consumables/deleteConsumableCart",
      EditCartItems: "consumables/editConsumableCart",
      SaveStock: "consumables/addConsumableStock",
      FetchModes: "setting/fetchPaymentOptions",
      FetchSuppliers: "stock/fetchSuppliers",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
    }),

    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addPriceCommas(){
      this.data.unit_price = this.thousandSeprator(this.data.unit_price);
    },
    editPriceCommas(){
      this.editdata.unit_price = this.thousandSeprator(this.editdata.unit_price);
    },

    checkItem() {
      if (this.data.product != "") {
        this.existingItem = this.ConsumablesCart.filter((item) => {
          return item.item.id == this.data.product;
        });
        if (this.existingItem.length) {
          this.itemError = "This Item exists already";
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    resetData() {
      this.data.product = "";
      this.data.unit_price = "";
      this.data.quantity = "";
    },
    resetDeleteItem(modalId) {
      this.closeModal(modalId);
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetEdit(modalId) {
      this.closeModal(modalId);
      this.editdata.product = "";
      this.editdata.id = "";
      this.editdata.quantity = "";
      this.editdata.unit_price = "";
      this.modal_id = "";
    },

    resetErrors() {
      this.itemError = "";
      this.quantityError = "";
      this.priceError = "";
    },

    showEditModal(data) {
      this.editdata.product = data.item.id;
      this.editdata.name = data.item.name;
      this.editdata.id = data.id;
      this.editdata.quantity = data.quantity;
      this.editdata.unit_price = this.thousandSeprator(data.unit_price);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.id;
    },
    editItem(modalId) {
      this.modal_id = modalId;
      this.EditCartItems(this.editdata);
    },

    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
    },
    saveStock() {
      if (this.totals.mode == "") {
        this.modeError = "Payment option field is required";
        return;
      } else {
        this.modeError = "";
      }
      if (this.totals.paid <  this.totals.total && this.totals.supplier == '') {
        this.supplierError = "Suppier field is required";
        return;
      } else {
        this.supplierError = "";
      }
      this.SaveStock(this.totals);
      this.totals.paid = 0;
      
    },
    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      if (this.data.unit_price == "") {
        this.priceError = "Unit Price Field is required";
        return;
      } else {
        this.unit_priceError = "";
      }
      if (this.existingItem.length) {
        this.itemError = "This Item exists already please";
        return;
      } else {
        this.itemError = "";
      }
      this.AddCart(this.data);
    },
    paidCommas(){
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas(){
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetErrors();
      });
    },

    setDefaultMode(){
      let defaultop = this.PaymentOptions?this.PaymentOptions:[].filter((mode)=>{
            return mode.default == 1;
        })
        this.totals.mode = defaultop[0]?defaultop[0].id:0;
    },
    resetmodeError() {
      this.modeError = "";
    },
    resetPaidError() {
      this.PaidError = "";
    },
  },
  updated(){
    let total_amount = 0;
    if(this.ConsumablesCart){      
        this.ConsumablesCart.forEach((item)=>{
          total_amount = total_amount+parseInt(item.unit_price*item.quantity);      
      });
      this.totals.total = total_amount;
    }
  },

  watch: {
    ConsumablesCart(newValue){
      if(newValue == true){
        this.FetchConsumablesCart();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    }
  },
  created() {
    this.FetchConsumables();
    this.FetchConsumablesCart();
    this.FetchSuppliers();
    this.FetchModes();
    this.FetchGeneralSettings();
    setTimeout(()=> {
         this.setDefaultMode();
    }, 3000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Items in Cart</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ConsumablesCart ? ConsumablesCart : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.unitprice
                        ? thousandSeprator(data.item.unit_price * data.item.unit_price)
                        : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{ data.item.unit_price ? thousandSeprator(data.item.unit_price) : 0 }}
                </template>
                <template #cell(quantity)="data">
                  {{ data.item ? data.item.quantity : 0 }} {{data.item.unit.name}}
                </template>

                <template #cell(actions)="data">
                  <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-item-modal
                      class="m-2"
                      @click="showEditModal(data.item)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      v-b-modal.delete-item-modal
                      variant="danger"
                      size="sm"
                      @click="showDeleteModal(data.item)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </template>
              </b-table>

              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader v-if="!ConsumablesCart" />
            <div class="row" v-if="totals.total > 0">
              <div class="col-12 text-center mt-4">
                <h4>
                  <strong
                  >TOTAL:
                    {{
                      thousandSeprator(totals.total)
                    }}/=</strong
                  >
                </h4>
              </div>
            </div>

            <b-form v-if="totals.total > 0">              
              <div class="row">                
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Amount Paid <span class="text-danger">*</span></label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.paid"
                      ref="Amountpaid"
                      @input="paidCommas()"
                      @keyup.enter="saveStock()"
                      min="0"
                    />
                  </div>
                  <div class="text-danger" v-if="PaidError">
                    <em>{{ PaidError }}</em>
                  </div>
                </div>
                <div class="col-md-3" v-show="GeneralSettings.purchase_discount == 1">
                  <div class="form-group">
                    <label>Discount Received</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.discount"
                      @input="discountCommas()"
                      min="0"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Payment Method <span class="text-danger">*</span></label>
                    <model-list-select
                      :list="PaymentOptions ? PaymentOptions : []"
                      v-model="totals.mode"
                      option-value="id"
                      option-text="mode"
                      placeholder="Select Method"
                      @input="resetmodeError()"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="modeError">
                    <em>{{ modeError }}</em>
                  </div>
                </div>
                <div class="col-md-3" v-show="GeneralSettings.capture_purchase_invoiceno == 1">
                  <div class="form-group">
                    <label>Invoice No.</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="totals.invoice"
                    />
                  </div>
                </div>
                <div class="col-md-4" v-if="GeneralSettings.track_suppliers == 1">
                  <div class="form-group">
                    <label>Supplier </label>
                    <model-list-select
                      :list="Suppliers ? Suppliers : []"
                      v-model="totals.supplier"
                      option-value="id"
                      option-text="name"
                      placeholder="Select Supplier"
                    >
                    </model-list-select>
                  </div>
                  <div class="text-danger" v-if="supplierError">
                    <em>{{ supplierError }}</em>
                  </div>
                </div>

                <div class="form-group col-md-4">
                  <label>Date <span class="text-danger">*</span></label>
                  <input
                      type="date"
                      class="form-control"
                      v-model="totals.date"
                      placeholder="Enter Date"
                      v-limit-future-date
                  />
                </div>
                <div v-if="MyUserPerm.stocking_consumables== 1 && SaveStatus" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" disabled
                  ><i class="fa fa-check"></i> Save Stock
                    <b-spinner
                        variant="light"
                        label="Spinning"
                    ></b-spinner>
                  </b-button>
                </div>
                <div v-if="MyUserPerm.stocking_consumables== 1 && !SaveStatus" class="col-md-4 mt-4">
                  <b-button variant="primary" class="pull-center" @click="saveStock()"
                  ><i class="fa fa-check"></i> Save Stock
                  </b-button>
                </div>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">

              <div class="form-group mb-3">
                <label>Product <span class="text-danger">*</span></label>
                <model-list-select
                    :list="Consumables ? Consumables : []"
                    v-model="data.product"
                    option-value="id"
                    option-text="nameto_select"
                    placeholder="Select Product"
                    @input="resetErrors(), checkItem()"
                >
                </model-list-select>
                <div class="text-danger" v-if="itemError">
                  <em>{{ itemError }}</em>
                </div>
              </div>
              <div class="row">
                  <div class="form-group mb-3">
                    <label>Quantity <span class="text-danger">*</span></label>
                    <input
                        type="number"
                        class="form-control"
                        step="any"
                        v-model="data.quantity"
                        @input="resetErrors()"
                        placeholder="Enter Quantity"
                    />
                    <div class="text-danger" v-if="quantityError">
                      <em>{{ quantityError }}</em>
                    </div>
                  </div>
              </div>
              <div class="form-group mb-3">
                <label>Unit Price <span class="text-danger">*</span></label>
                <input
                    type="text"
                    class="form-control"
                    step="any"
                    v-model="data.unit_price"
                    @input="resetErrors(),addPriceCommas()"
                    placeholder="Enter Unit Price"
                />
                <div class="text-danger" v-if="priceError">
                  <em>{{ priceError }}</em>
                </div>
              </div>
              <div class="form-group text-center">
                <b-button
                    @click="addToCart()"
                    variant="primary"
                ><i class="fa fa-plus"></i> Add
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                  ></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" class="text-primary" hide-footer @hidden="resetEdit()">
      <template #modal-title>
        Edit Item {{ editdata.name }}</template
      >
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input
            type="number"
            class="form-control"
            step="any"
            v-model="editdata.quantity"
        />
      </div>
      <div class="form-group mb-3">
        <label>Unit Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.unit_price" @input="editPriceCommas()"/>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editItem('edit-item-modal')"
        >
          <i class="fa fa-check"></i> Save Changes
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" class="text-danger" hide-footer @hidden="resetDeleteItem">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-item-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteItem('delete-item-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--  end row -->
  </Layout>
</template>
<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>